<template>
  <div>
    <el-button icon="el-icon-refresh" @click="$refresh(getTollmanStatistics)" class="refresh-btn">刷新</el-button>
    <div class="wrap count">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="医馆名称">
            <el-select v-model="searchForm.deptIds" multiple placeholder="请选择医馆名称">
              <el-option v-for="item in deptOptions" :key="item.value"  :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="月份">
            <el-date-picker v-model="searchForm.date" value-format="yyyy-MM" type="monthrange" align="right"
            unlink-panels range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份"
            :picker-options="pickerOptions" @change="val => $setDates(val, getTollmanStatistics)"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getTollmanStatistics, true)">查询</el-button>
            <el-button icon="el-icon-refresh" @click="$reset(getTollmanStatistics, { deptIds: [], dates: [], date: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
        <el-button @click="$exportSummary(searchForm, '/report/export/tollCollector', '员工收费统计')"
          icon="el-icon-download" type="primary">导出报表</el-button>
      </div>
      <!-- 员工收费统计列表 -->
      <el-table v-loading="loading" :data="tollmanStatisticsList" :max-height="tableHeight" border>
        <el-table-column fixed prop="payee" width="100" label="收费员"/>
        <el-table-column label="营业收费">
          <el-table-column  label="收款总额(元)" min-width="110">
            <template slot-scope="scope">{{scope.row.totalPrice}}</template>
          </el-table-column>
          <el-table-column  label="退款金额(元)" min-width="110">
            <template slot-scope="scope">{{scope.row.refundPrice}}</template>
          </el-table-column>
          <el-table-column  label="实收金额(元)" min-width="110">
            <template slot-scope="scope">{{scope.row.realPay}}</template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="支付方式">
          <el-table-column  label="现金(元)" min-width="80">
            <template slot-scope="scope">{{scope.row.payWay.cashPrice}}</template>
          </el-table-column>
          <el-table-column  label="线下微信(元)" min-width="110">
            <template slot-scope="scope">{{scope.row.payWay.wechatOFPrice}}</template>
          </el-table-column>
          <el-table-column  label="线上微信(元)" min-width="110">
            <template slot-scope="scope">{{scope.row.payWay.wechatOLPrice}}</template>
          </el-table-column>
          <el-table-column  label="支付宝(元)" min-width="90">
            <template slot-scope="scope">{{scope.row.payWay.aliPrice}}</template>
          </el-table-column>
          <el-table-column  label="银行卡(元)" min-width="90">
            <template slot-scope="scope">{{scope.row.payWay.bankCardPrice}}</template>
          </el-table-column>
          <el-table-column  label="医保卡(元)" min-width="90">
            <template slot-scope="scope">{{scope.row.payWay.socialSecurityPrice}}</template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="费用分类">
          <el-table-column  label="中药饮片(元)" min-width="110">
            <template slot-scope="scope">{{scope.row.classify.ornamentPrice}}</template>
          </el-table-column>
          <el-table-column  label="中药颗粒(元)" min-width="110">
            <template slot-scope="scope">{{scope.row.classify.granulePrice}}</template>
          </el-table-column>
          <el-table-column  label="理疗费(元)" min-width="90">
            <template slot-scope="scope">{{scope.row.classify.physioPrice}}</template>
          </el-table-column>
          <el-table-column  label="挂号费(元)" min-width="90">
            <template slot-scope="scope">{{scope.row.classify.registerPrice}}</template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getTollmanStatistics)" :total="total"
      :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"/>
    </div>
  </div>
</template>

<script lang="js">
import { tollmanStatistics } from "@/api/statement"; // 报表统计请求
export default {
  name: 'StaffChargeOverview',
  data() {
    return {
      loading: false, // 加载中
      searchForm: { deptIds: [], dates: [], date: null }, // 查询表单
      tollmanStatisticsList: [], // 员工收费统计列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      deptOptions: this.$session.get('options'), // 医馆列表
      pickerOptions:{ // 排班日期可选范围
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: this.$shortcuts
      },
      tableHeight: 0, // 表格最大高度
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.$forceUpdate();
    this.$setCurMonth(this.getTollmanStatistics);
  },
  methods: {
    // 请求所有员工收费统计列表
    async getTollmanStatistics() {
      let { rows, code, total } = await tollmanStatistics(this.currentPage, this.pageSize, this.searchForm);
      if (code == 200) {
        this.tollmanStatisticsList = rows;
        this.total = total;
      }
      this.loading = false;
    }
  },
};
</script>